// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gPei","delete":"styles_delete__1sPaI","update":"styles_update__3QQXc","add":"styles_add__7A-Nx"};